__turbopack_context__.v({
  "className": "G46osa_className",
  "variable": "G46osa_variable",
});
